import React from 'react';
import AppIntegrationCard, { AppIntegration } from '@components/AppIntegrationCard';
import { Divider } from 'antd';
import { useAppDispatch } from '@core/configureStore';
import { openDrawer } from '@core/features';
import AppIntegrationDrawer from '@components/AppIntegrationDrawer';

type Props = {};

type AppIntegrationId = 'SQUARE';
type ExtendedAppIntegration = AppIntegration & { onClick: any };

const AppIntegrationScreen = (props: Props) => {
  const dispatch = useAppDispatch();
  const onAppIntegrationClicked = (appId: AppIntegrationId) => {
    dispatch(
      openDrawer({
        drawerName: 'appIntegrationDrawer',
        extraParams: {
          appId,
        },
      })
    );
  };

  const apps: ExtendedAppIntegration[] = [
    {
      icon: <img alt="Square logo" src="square-inc.png" />,
      title: 'Square',
      description: 'Automatically send post-purchase review invitations to customers.',
      onClick: () => onAppIntegrationClicked('SQUARE'),
    },
  ];

  return (
    <React.Fragment>
      <div className="screen-card">
        <h3>Integrations</h3>
        <Divider />
        {apps.map(appIntegration => (
          <AppIntegrationCard app={appIntegration} onClick={appIntegration.onClick} />
        ))}
      </div>
      <AppIntegrationDrawer />
    </React.Fragment>
  );
};

export default AppIntegrationScreen;
